import React, {FC, PropsWithChildren} from 'react';

type MobileConfig = {
	mobile?: boolean
}

const MobileContext = React.createContext<MobileConfig>({});

export const useIsMobile = () => {
	const {mobile} = React.useContext(MobileContext);
	return Boolean(mobile);
};

export const MobileProvider: FC<PropsWithChildren> = ({children}) => {
	return (
		<MobileContext.Provider value={{mobile: true}}>
			{children}
		</MobileContext.Provider>
	);
};
